
let map;

const url = 'https://inaessentials-backend-1065353067715.europe-west1.run.app/api/v1';
const countryCode = 'bg';

let locations = [];

const citySelector = document.querySelector('#location-city-selector');
const typeSelector = document.querySelector('#location-type-selector');
let cities = [];
let types =[];
let markers = [];


const defaultMapCenter = {lat: 42.77648852347108, lng: 25.553771832084973}
const defaultMapZoom = 7;
const defaultMapZoomOnMobile = 6;

const isMobile = ()=>{
    return window.matchMedia("(max-width: 768px)").matches;
}

const mediaQuery = '(max-width: 768px)';
const mediaQueryList = window.matchMedia(mediaQuery);

mediaQueryList.addEventListener('change', event => {
    console.log(window.innerWidth);
  if (event.matches) {
    map.setZoom(defaultMapZoomOnMobile);
  } else {
    map.setZoom(defaultMapZoom);
  }
})




const getLocations = ()=>{
    return fetch(`${url}/location/country/${countryCode}`).then(resp=>resp.json()).then(data=>{
        console.log(data.locations)
       locations = data.locations.filter(location=>location.coordinates);
    })
}

const fillSelectors = () => {
    const typeMappings = {
        all:"Всички",
        pharmacy: "Аптека",
        store: "Магазин",
    }

     cities = new Set(locations.map(location => location.city));
     types = new Set(locations.map(location => location.type));

    citySelector.add(new Option("Всички", "all"));
    typeSelector.add(new Option("Всички", "all"));

    cities.forEach(city => {
        citySelector.add(new Option(city, city));
    })
    types.forEach(type => {
        typeSelector.add(new Option(typeMappings[type], type));
    })
}

const createMarker = (location,addNavigation,groupMarker = false)=>{
    const myLatLng = {lat: +location.coordinates.split(',')[0], lng: +location.coordinates.split(',')[1]};
    const contentString = `
            <div id="content">
            <div id="siteNotice">
            </div>
            <h1 id="firstHeading" class="firstHeading">${location.name}</h1>
            <div id="bodyContent">
            <p>
            ${addNavigation?`<a href="https://google.com/maps/dir//${location.coordinates.replace(' ','')}" target="_blank">
        ${location.address}
    </a>`: location.address}
            
               
            </p>

            </div>
            </div>`;
            const icon ={
                url: "https://cdn.shopify.com/s/files/1/2518/6068/files/INA_google-maps-marker.png?v=1686552461",
                scaledSize: new google.maps.Size(70, 60),
            }

    const marker = new google.maps.Marker({
        position: myLatLng,
        map,
        icon:location.important && !groupMarker?icon:null,
        title: location.name,
    });

    const infowindow = new google.maps.InfoWindow({
        content: contentString,
        ariaLabel: "Location",
    });

    marker.addListener("click", () => {
        if(groupMarker){
            citySelector.value = location.city;
            handleSelectorValueChange();
        }else{
            closeAllOtherInfoWindows();
            infowindow.open({
                anchor: marker,
                map,
            });
        }
        
    });

    const markerObject = {
        city:location.city,
        type:location.type,
        marker,
        infowindow
    }
    return markerObject;
}

const closeAllOtherInfoWindows = ()=>{
    markers.forEach(marker=>{
        marker.infowindow.close();
    })
}

const addMarkers = () => {
    deleteMarkers();
    let newLocations = locations.filter(location=>location.city===citySelector.value);

    const center = {lat: parseFloat(newLocations[0].coordinates.split(',')[0]), lng: parseFloat(newLocations[0].coordinates.split(',')[1])}
    setNeMapCenter(center,10)
    if(typeSelector.value !=="all"){
        newLocations =  newLocations.filter(location=>location.type === typeSelector.value);
    }

    newLocations.forEach(location => {
        markers.push(createMarker(location,true));
    })

}

const setNeMapCenter = (center,zoom)=>{

    map.setCenter(center);
    map.setZoom(zoom);
}

const groupMarkers = (groupBy='city')=>{
    deleteMarkers();

    cities.forEach(city=>{
        const location = locations.find(loc=>loc.city==city);
        let description =`Общо обекти: ${groupBy === 'city'?locations.filter(location=>location.city==city).length:locations.filter(location=>location.type==typeSelector.value&&location.city==city).length} `
        const marker = createMarker({
            ...location,
            name:city,
            description
        },false,true)
        markers.push(marker);
    });
}

const deleteMarkers = ()=>{
    markers.forEach(marker=>{
        marker.marker.setMap(null);
    })
    markers = [];
}

const addSelectorEventListeners = ()=>{
    citySelector.addEventListener('change',ev=>handleSelectorValueChange());
    typeSelector.addEventListener('change',ev=>handleSelectorValueChange());
}



const handleSelectorValueChange = ()=>{
    if(citySelector.value === "all" && typeSelector.value === "all"){
        setNeMapCenter(defaultMapCenter,isMobile()?defaultMapZoomOnMobile:defaultMapZoom)
        return groupMarkers();
    }
    if(citySelector.value === "all" && typeSelector.value !== "all"){
        setNeMapCenter(defaultMapCenter,isMobile()?defaultMapZoomOnMobile:defaultMapZoom)
        return groupMarkers('type');
    }
    return addMarkers();
}

async function initMap() {
    //@ts-ignore
    const {Map} = await google.maps.importLibrary("maps");
    map = new Map(document.getElementById("map"), {
        center:defaultMapCenter,
        zoom:isMobile()?defaultMapZoomOnMobile:defaultMapZoom
    });

}


initMap().then(() => {
   getLocations().then(()=>{
       fillSelectors();
       groupMarkers();
       //addMarkers();
       addSelectorEventListeners();
   });

});